import React, { useEffect, useState } from 'react';
import { GetTCards_GetItems } from '../../../Core/Service/T-card-services';
import { Button, Grid, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Checkbox, CircularProgress } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/styles';
import { SecondaryButton } from '../../../Core/FormInput';
import formatters from '../../../Core/Grid/inputFormatter';
import { getJobLabourLines } from '../../../Core/Service/workflowJobs-service';

const useStyles = makeStyles((theme) => ({
    root: { marginTop: 15 },
    table: { minWidth: 950 },
    tableContainer: {
        height: 300,
        border: '1px solid rgba(0,0,0,0.2)'
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center'
    }
}));

const StyledTableRow = withStyles(() => ({
    root: { cursor: 'pointer' }
}))(TableRow);

const StyledTableCell = withStyles(() => ({
    head: {
        fontSize: 15,
        fontWeight: 600,
        backgroundColor: '#bdbdbd82',
        padding: '6px 8px'
    },
    body: {
        fontSize: 14,
        padding: '6px 8px'
    }
}))(TableCell);

const ImportLabourTable = ({ jobId, onSubmitImportLabourListHandler }) => {
    const classes = useStyles();
    const [tCardLineItems, setTCardLineItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isAllSelect, setIsAllSelect] = useState(false);

    useEffect(() => {
        const fetchTCardItems = async () => {
            setLoading(true);
            try {
                const res = await getJobLabourLines(jobId);
                setTCardLineItems(res.data.parts || []);
            } finally {
                setLoading(false);
            }
        };
        fetchTCardItems();
    }, [jobId]);

    const onJobSelect = (checked, lne) => {
        setTCardLineItems((prevItems) => prevItems.map((item) => (item.lne === lne ? { ...item, isSelected: checked } : item)));
    };

    const onJobAllSelect = (e) => {
        setIsAllSelect(e.target.checked);
        setTCardLineItems((prevItems) => prevItems.map((item) => ({ ...item, isSelected: e.target.checked })));
    };

    const handleSubmit = () => {
        onSubmitImportLabourListHandler(tCardLineItems.filter((q) => q.isSelected));
    };

    return (
        <Grid container spacing={2} alignItems="center" justifyContent="center">
            {loading ? (
                <Grid item xs={12} style={{ height: '300px', textAlign: 'center' }}>
                    <CircularProgress />
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <TableContainer className={classes.tableContainer}>
                        <Table className={classes.table} size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell width="5%">
                                        <Checkbox nmae="isAllSelect" checked={isAllSelect || false} color="primary" onChange={onJobAllSelect} />
                                    </StyledTableCell>
                                    <StyledTableCell width="10%">Line</StyledTableCell>
                                    <StyledTableCell width="60%">Description/Comments</StyledTableCell>
                                    <StyledTableCell width="30%">Time Invoiced</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tCardLineItems.map((q) => (
                                    <StyledTableRow key={q.lne}>
                                        <StyledTableCell>
                                            <Checkbox checked={q.isSelected || false} color="primary" onChange={(e) => onJobSelect(e.target.checked, q.lne)} />
                                        </StyledTableCell>
                                        <StyledTableCell>{q.lne}</StyledTableCell>
                                        <StyledTableCell>{q.description}</StyledTableCell>
                                        <StyledTableCell>{q.timeSpent}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            )}
            <Grid item xs={12}>
                <SecondaryButton fullWidth onClick={handleSubmit} disabled={tCardLineItems.filter((q) => q.isSelected).length <= 0 || loading}>
                    Submit
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default ImportLabourTable;
